import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Icon } from '@mademine/components';
import { I18n } from '@mademine/utils';
import { ReactComponent as IconFlip } from '../../../assets/icon-flip.svg';
var FlipButton = function (_a) {
    var className = _a.className, handleFlip = _a.handleFlip, currentSide = _a.currentSide;
    var _b = useState(currentSide), sideText = _b[0], setSideText = _b[1];
    return (_jsxs("div", { className: "_sz-gap-[2px] _sz-p-2 _sz-h-16 _sz-w-20 _sz-bg-[#F1F1F1] _sz-rounded ".concat(className, " _sz-flex _sz-cursor-pointer _sz-flex-col _sz-items-center _sz-justify-center"), onClick: function () {
            handleFlip();
            setSideText(sideText == 1 ? 2 : 1);
        }, children: [_jsx(Icon, { size: 30, color: "#000", className: "_sz-w-full", children: _jsx(IconFlip, {}) }), _jsx("span", { className: " _sz-max-w-[80px] _sz-text-xs _sz-font-semibold _sz-leading-3 _sz-text-black", children: sideText === 1
                    ? I18n.format('modules.mini.me.flip.back')
                    : I18n.format('modules.mini.me.flip.front') })] }));
};
export default FlipButton;
